import React from 'react'

import { getNavigationIcon } from '@/constants/navigationAssets'

import { formatDateString } from '@/utils/formatDateString'

import { Container, CloseIcon, Text } from './Filters.styled'
import { FilterOptionTypes } from './Filters.types'

export type FilterOptionProps = {
  option: FilterOptionTypes
  onClick: (id: string) => void
}

const FilterOption: React.FC<FilterOptionProps> = ({ option, onClick }) => {
  let dates: any = []

  if (option.id === 'date') {
    dates = option.value.split(' - ')
  }

  return (
    <Container>
      {dates.length > 1 ? (
        <Text>
          {formatDateString(dates[0])}
          {'-'}
          {formatDateString(dates[1])}
        </Text>
      ) : (
        <Text>{option.value}</Text>
      )}
      <CloseIcon
        src={getNavigationIcon('close')}
        onClick={() => onClick(option.id)}
      />
    </Container>
  )
}

export default FilterOption
